'use strict';

var GRID_DATE_FORMAT_REGEX = /^\d{4}-\d{2}-\d{2}$/;

function isValidGridDateString(value) {
    if (value == null || value === '') return false;
    var s = String(value).trim();
    if (!GRID_DATE_FORMAT_REGEX.test(s)) return false;
    var parts = s.split('-');
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    var dt = new Date(Date.UTC(y, m - 1, d));
    return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
}

function formatIsoToGridDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var m = d.getUTCMonth() + 1;
    var day = d.getUTCDate();
    return d.getUTCFullYear() + '-' +
        (m < 10 ? '0' : '') + m + '-' +
        (day < 10 ? '0' : '') + day;
}

function isInvalidDateFilterEntry(value) {
    if (!Array.isArray(value) || value.length < 2) return false;
    // Solo se considera "entrada de fecha" (que puede ser inválida) si todos los
    // elementos parecen fechas o marcadores de fecha incompleta. Si algún elemento
    // es claramente otra cosa (ej. una selección de set filter como 'Validar (1)'),
    // no se trata de un filtro de fecha y no debe descartarse.
    var hasBadDatePart = false;
    for (var i = 0; i < value.length; i++) {
        var v = value[i];
        if (v == null || v === '') { hasBadDatePart = true; continue; }
        var s = String(v);
        if (s.indexOf('undefined') >= 0 || s.startsWith('T')) { hasBadDatePart = true; continue; }
        if (isValidGridDateString(s.substring(0, 10))) continue;
        return false;
    }
    return hasBadDatePart;
}

/**
 * Fecha calendario YYYY-MM-DD como la muestra dateRenderer (sin desfase por UTC).
 */
function toGridCalendarDateString(value) {
    if (value == null || value === '') return null;
    var s = String(value).trim();
    if (GRID_DATE_FORMAT_REGEX.test(s)) {
        return s;
    }
    if (s.length === 10) {
        s = s.concat('T00:00');
    }
    var date = new Date(s);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
}

module.exports = {
    GRID_DATE_FORMAT_REGEX: GRID_DATE_FORMAT_REGEX,
    isValidGridDateString: isValidGridDateString,
    formatIsoToGridDate: formatIsoToGridDate,
    isInvalidDateFilterEntry: isInvalidDateFilterEntry,
    toGridCalendarDateString: toGridCalendarDateString
};
